// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.sprite-info_sprite-info_KuOeW {
    padding: 0.75rem;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: var(--ui-white);
    color: var(--text-primary);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-bottom: 1px solid var(--ui-black-transparent);
}

.sprite-info_row_Nd1fl {
    display: flex;
    justify-content: space-between;
}

.sprite-info_row-primary_Vliim {
    margin-bottom: 0.5rem;
}

.sprite-info_label_wIJSK { opacity: 0.8; }

.sprite-info_group_MAeKN {
    display: inline-flex;
    flex-direction: row; /* makes columns, for each label/form group */
    align-items: center;
}

.sprite-info_column_NSzxA {
    display: inline-flex;
    flex-direction: column; /* put label above input */
    align-items: flex-start;
}

.sprite-info_column_NSzxA span {
    margin-bottom: .25rem;
}

.sprite-info_icon-wrapper_jwcn9 {
    display: inline-block;
    width: calc(2rem + 2px);
    height: calc(2rem + 2px);
    padding: 0.5rem;
    outline: none;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    filter: var(--filter-icon-gray);
}

.sprite-info_icon_flm4b {
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.sprite-info_rotation-select_fJR73 {
    width: 100%;
    height: 1.85rem;
    border: 1px solid var(--ui-black-transparent);
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    outline: none;
}

.sprite-info_rotation-select_fJR73:focus {
    border-color: var(--looks-secondary);
    box-shadow: inset 0 0 0 1px var(--ui-black-transparent);
}

.sprite-info_larger-input_zYVUJ input {
    width: 4rem;
}

.sprite-info_sprite-input_B6zoF {
    width: 8rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/sprite-info/sprite-info.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,2DAA2D;IAC3D,iCAAiC;IACjC,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAAS,YAAY,EAAE;;AAEvB;IACI,oBAAoB;IACpB,mBAAmB,EAAE,6CAA6C;IAClE,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB,EAAE,0BAA0B;IAClD,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,6CAA6C;IAC7C,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,uDAAuD;AAC3D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.sprite-info {\n    padding: 0.75rem;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background-color: var(--ui-white);\n    color: var(--text-primary);\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    border-bottom: 1px solid var(--ui-black-transparent);\n}\n\n.row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.row-primary {\n    margin-bottom: 0.5rem;\n}\n\n.label { opacity: 0.8; }\n\n.group {\n    display: inline-flex;\n    flex-direction: row; /* makes columns, for each label/form group */\n    align-items: center;\n}\n\n.column {\n    display: inline-flex;\n    flex-direction: column; /* put label above input */\n    align-items: flex-start;\n}\n\n.column span {\n    margin-bottom: .25rem;\n}\n\n.icon-wrapper {\n    display: inline-block;\n    width: calc(2rem + 2px);\n    height: calc(2rem + 2px);\n    padding: 0.5rem;\n    outline: none;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    filter: var(--filter-icon-gray);\n}\n\n.icon {\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n}\n\n.rotation-select {\n    width: 100%;\n    height: 1.85rem;\n    border: 1px solid var(--ui-black-transparent);\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    outline: none;\n}\n\n.rotation-select:focus {\n    border-color: var(--looks-secondary);\n    box-shadow: inset 0 0 0 1px var(--ui-black-transparent);\n}\n\n.larger-input input {\n    width: 4rem;\n}\n\n.sprite-input {\n    width: 8rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `sprite-info_sprite-info_KuOeW`;
export { _1 as "sprite-info" };
export var spriteInfo = `sprite-info_sprite-info_KuOeW`;
export var row = `sprite-info_row_Nd1fl`;
var _2 = `sprite-info_row-primary_Vliim`;
export { _2 as "row-primary" };
export var rowPrimary = `sprite-info_row-primary_Vliim`;
export var label = `sprite-info_label_wIJSK`;
export var group = `sprite-info_group_MAeKN`;
export var column = `sprite-info_column_NSzxA`;
var _3 = `sprite-info_icon-wrapper_jwcn9`;
export { _3 as "icon-wrapper" };
export var iconWrapper = `sprite-info_icon-wrapper_jwcn9`;
export var icon = `sprite-info_icon_flm4b`;
var _4 = `sprite-info_rotation-select_fJR73`;
export { _4 as "rotation-select" };
export var rotationSelect = `sprite-info_rotation-select_fJR73`;
var _5 = `sprite-info_larger-input_zYVUJ`;
export { _5 as "larger-input" };
export var largerInput = `sprite-info_larger-input_zYVUJ`;
var _6 = `sprite-info_sprite-input_B6zoF`;
export { _6 as "sprite-input" };
export var spriteInput = `sprite-info_sprite-input_B6zoF`;
export default ___CSS_LOADER_EXPORT___;
